import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DistributionHistoryEntity } from './distribution-history.entity';

@Entity('_distribution_definition')
export class DistributionDefinitionEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('text', { name: '_description' })
	public description!: string;

	@Column('int', { name: '_fk__object__id_assignee', unsigned: true })
	public fkObjectIdAssignee!: number;

	@Column('text', { name: '_assigneeQuery' })
	public assigneeQuery!: string;

	@Column('int', {
		name: '_fk__object_field__id_assigneeIdentifier',
		unsigned: true,
	})
	public fkObjectFieldIdAssigneeIdentifier!: number;

	@Column('int', {
		name: '_fk__object_field__id_assigneeCount',
		unsigned: true,
	})
	public fkObjectFieldIdAssigneeCount!: number;

	@Column('int', {
		name: '_fk__object_field__id_assigneeLimit',
		unsigned: true,
	})
	public fkObjectFieldIdAssigneeLimit!: number;

	@Column('int', {
		name: '_fk__object_field__id_assigneeFilter',
		unsigned: true,
	})
	public fkObjectFieldIdAssigneeFilter!: number;

	@Column('int', { name: '_fk__object__id_resource', unsigned: true })
	public fkObjectIdResource!: number;

	@Column('text', { name: '_resourceQuery' })
	public resourceQuery!: string;

	@Column('int', {
		name: '_fk__object_field__id_resourceAssigneeIdentifier',
		unsigned: true,
	})
	public fkObjectFieldIdResourceAssigneeIdentifier!: number;

	@Column('text', { name: '_assigneeCountFilter' })
	public assigneeCountFilter!: string;

	@Column({
		type: 'boolean',
		name: '_enforceEvenDistributionCap',
		width: 1,
		default: () => "'0'",
	})
	public enforceEvenDistributionCap!: boolean;

	@Column('varchar', {
		name: '_roundRobinSort',
		length: 255,
		default: () => "'AVAILABLE_COUNT_DESC'",
	})
	public roundRobinSort!: string;

	@Column('longtext', { name: '_resourceExclusionQuery', nullable: true })
	public resourceExclusionQuery!: string | null;

	@Column('text', { name: '_workflowResourceQueryFilter' })
	public workflowResourceQueryFilter!: string;

	@OneToMany(
		() => DistributionHistoryEntity,
		(distributionHistory) => distributionHistory.fkDistributionDefinition,
		{},
	)
	public distributionHistories!: Array<DistributionHistoryEntity>;
}
